import { Badge, Box, Stack, styled } from '@mui/material';
import { alpha } from '@mui/material/styles';

export const UploadButtonContainer = styled(Box)({
  width: '1rem',
  height: '1rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: '#F3F4F6',
  borderRadius: '0.5rem',
  color: '#6B7280',
  cursor: 'pointer',
  transition: 'all 0.2s ease-in-out',
  '&:hover': {
    backgroundColor: '#E5E7EB',
    transform: 'scale(1.1)',
    color: '#111827',
  },
});

export const DragContainer = styled(Stack, {
  shouldForwardProp: (prop) => prop !== 'isDragging',
})<{ isDragging?: boolean }>(({ isDragging, theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'flex-start',
  position: 'relative',
  borderRadius: '8px',
  transition: 'all 0.2s ease',
  backgroundColor: isDragging ? alpha(theme.palette.accent.main, 0.1) : 'transparent',
  outline: isDragging ? `2px dashed ${theme.palette.accent.main}` : 'none',
  minHeight: '32px',
  padding: isDragging ? '4px' : '0',
  width: '100%',
}));

export const PdfThumbnailContainer = styled(Box)({
  cursor: 'pointer',
  width: '1.25rem',
  height: '1.25rem',
  objectFit: 'cover',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '4px',
  border: '1px solid #F9FAFB',
  boxShadow: '0px 1px 3px 0px rgba(0, 0, 0, 0.10), 0px 1px 5px 0px rgba(0, 0, 0, 0.06)',
  marginLeft: '2px',
  padding: '10px',
  transition: 'all 0.2s',
  '&:hover': {
    backgroundColor: '#F3F4F6',
    borderColor: '#E5E7EB',
  },
});

export const PdfBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    backgroundColor: theme.palette.accent.main,
    fontSize: '0.6rem',
    height: '16px',
    minWidth: '16px',
    padding: '0 4px',
    right: -3,
    top: -3,
  },
}));
